import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "postme.me - idea to sales in 3 days",
  "description": "",
  "published": "2011-10-20T00:00:00.000Z",
  "redirect_from": ["/blog/postme-me-idea-to-sales-in-3-days/swizec/2690"],
  "categories": "Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Last weekend I did an experiment in extreme `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Lean_Startup"
      }}>{`Lean`}</a>{`.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/10/57cab9bec4c74bf2b3c7ded9f6675d02_78.jpg",
        "alt": null,
        "title": "First batch"
      }}></img></p>
    <p>{`It worked out! I launched a product in 3 days and when I woke up on Tuesday there were four `}<em parentName="p">{`"Notification of payment received"`}</em>{` emails in my inbox.`}</p>
    <p>{`The idea behind `}<a parentName="p" {...{
        "href": "http://postme.me"
      }}>{`postme.me`}</a>{` is pretty simple - postcards are cool! Let's have a service to send cool postcards all over the world for cheap.`}</p>
    <p>{`Actually the idea didn't pop up 3 days before launch. It was brewing for a while ... the beginnings can be traced back to a silly evening at the DoubleRecall headquarters in `}<a parentName="p" {...{
        "href": "http://maps.google.com/maps?ll=37.4291666667,-122.138055556&spn=0.1,0.1&q=37.4291666667,-122.138055556%20(Palo%20Alto%2C%20California)&t=h",
        "title": "Palo Alto, California"
      }}>{`Palo Alto`}</a>{`. We were messing about and somebody said "Fuck man, you're not making it better!".`}</p>
    <p>{`Five minutes later I bought notmakingitbetter.com ... we raced even, I clicked the fastest.`}</p>
    <p>{`The following day I started thinking about what I could possibly do with this domain. Heading for a night of partying in `}<a parentName="p" {...{
        "href": "http://maps.google.com/maps?ll=37.7793,-122.4192&spn=0.1,0.1&q=37.7793,-122.4192%20(San%20Francisco)&t=h",
        "title": "San Francisco"
      }}>{`San Francisco`}</a>{` that evening, an idea to send "4chan cookies" to people popped up. Basically, you choose something from 4chan, we put it in a fortune cookie and send it anywhere.`}</p>
    <p>{`And that was that. My mind went and got occupied by other things.`}</p>
    <p>{`Until two weeks ago when I was going through a notebook and saw the idea jotted down - always carry a notebook guys ;) - surprisingly I still liked it. It got through the first test of worthiness!`}</p>
    <p>{`But `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Fortune_cookie",
        "title": "Fortune cookie"
      }}>{`fortune cookies`}</a>{`? That's not really viable, how the hell do you make those? Are there people who provide them? Would I bake them in my mum's kitchen?`}</p>
    <p>{`A few evenings later it clicked - POSTCARDS! Postcards are perfect for sending silly pictures to friends!`}</p>
    <p>{`I had no idea how postcards are made, but it seemed viable. Asked a designer friend if he can recommend a print shop - he recommended two. Sent out emails and one of the shops was kind enough to provide a price estimate without my knowing what the fuck it is that I even want.`}</p>
    <p>{`Next day I checked the local post office's prices and set the price of sending a postcard at $2. It's cheap enough for people to click without thinking much about it, and it covers my costs plus enough overhead to cover anything I didn't think of.`}</p>
    <p>{`That evening I forced myself to bed.`}</p>
    <p>{`Next morning I woke up and about 25 hours of coding and designing later, the website was born.`}</p>
    <p>{`Posted it to `}<a parentName="p" {...{
        "href": "http://news.ycombinator.com/",
        "title": "Hacker News"
      }}>{`HackerNews`}</a>{` and collapsed into bed.`}</p>
    <p><em parentName="p">{`"It's just an experiment. The site sucks. No point investing too much effort, if people won't click the magic button", `}{`_`}{`I kept telling myself. But really I was excited out of my mind. This was the first time in my life I wasn't giving a product away for free. This was edgy balls to the wall stuff for me - asking people for `}{`_`}{`money? On the internet!?`}</em>{` Madness!`}</p>
    <p>{`Next morning the website was full of naked pictures. But I did make some sales!`}</p>
    <p>{`Sweet!`}</p>
    <p>{`A couple of days later I convinced the print shop to let me do ultra small runs of prints. As little as 9 at a time, at almost the same price per card as doing 200. The post office also didn't bat an eyelid at my interesting postcards and dutifully sent them on their way.`}</p>
    <p>{`Two weeks since the idea originally crystalized in my head, the site still hasn't made enough sales for a full print run. But it has made enough sales to cover the costs of that first print of 9 cards. Even though most were sent to random people from `}<a parentName="p" {...{
        "href": "http://swizec.com/blog/i-learned-two-things-today-21-8/swizec/2275",
        "title": "I learned two things today 21.8."
      }}>{`my postcard escapade back in August`}</a>{`.`}</p>
    <p>{`The great thing about this whole project is that I know exactly where to fish for people. I know perfectly which sites I need to advertise on to reach my target customers and I know that even though there are many postcard services around, none seems to be targeting this niche for some reason.`}</p>
    <p>{`The only problem I have is that I can't afford the advertising.`}</p>
    <p>{`But projects without problems are boring.`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://ask.metafilter.com/198794/Fourcolor-postcards"
        }}>{`Four-color postcards?`}</a>{` (ask.metafilter.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.makeuseof.com/tag/create-send-real-postcard-phone-postcard-run/"
        }}>{`Create & Send A Real Postcard With Your Phone Using Postcard On The Run`}</a>{` (makeuseof.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.pixiq.com/article/from-pixels-to-postcards"
        }}>{`From Pixels to Postcards`}</a>{` (pixiq.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://kenleydarling.wordpress.com/2011/10/18/postagram-has-change-my-life-and-my-blog/"
        }}>{`Postagram has change my life! ...and my blog.`}</a>{` (kenleydarling.wordpress.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://printsunnysideup.wordpress.com/2011/10/13/postcards-a-thing-of-the-past-not-likely/"
        }}>{`Postcards: A Thing of the Past - Not Likely`}</a>{` (printsunnysideup.wordpress.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=e085b346-1171-4cf6-b176-82d9b31a998e",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      